/*
  Koleksiyon sayfası: ızgara düğmesi (wide | narrow, localStorage "alv-grid"). Vanilla JS.
*/

if (!customElements.get('alv-collection')) {
  class AlvCollection extends HTMLElement {
    connectedCallback() {
      this.gridBtns = Array.from(this.querySelectorAll('[data-alv-grid]'));
      this.gridBtns.forEach((btn) => btn.addEventListener('click', () => this.setGrid(btn.dataset.alvGrid)));
      this.syncGrid();
    }

    /* Geçiş anında, animasyonsuz; kaydırma konumu tarayıcıda korunur. wide: masaüstü 3 / mobil 2, narrow: 2 / 1 */
    setGrid(mode) {
      this.setAttribute('data-grid', mode);
      try {
        localStorage.setItem('alv-grid', mode);
      } catch (e) {}
      this.syncGrid();
    }

    syncGrid() {
      const mode = this.getAttribute('data-grid') || 'wide';
      this.gridBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.alvGrid === mode)));
    }
  }

  customElements.define('alv-collection', AlvCollection);
}

if (!customElements.get('alv-filter')) {
  class AlvFilter extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-alv-filter-panel]');
      this.opener = document.querySelector('[data-alv-filter-open]');
      if (this.opener) this.opener.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-alv-filter-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
        }
      });
    }

    open() {
      clearTimeout(this.hideTimer);
      this.hidden = false;
      void this.offsetWidth; // reflow — 260ms translateX geçişi oynasın
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
      trapFocus(this.panel, this.querySelector('.alv-filter__close'));
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
      removeTrapFocus(this.opener);
      this.hideTimer = setTimeout(() => {
        if (!this.hasAttribute('open')) this.hidden = true;
      }, 280);
    }
  }

  customElements.define('alv-filter', AlvFilter);
}
